import { PROGRAM_TYPES } from "../../program/constants";
import {
  calculateAllFinancialSupport,
  calculateFinancialSupport,
  toCurrency,
} from "../../../helpers";
import {
  IProgramListItemHigherBackEnd,
  IProgramListItemHigherFrontEnd,
} from "../types";

const getProgramTypeName = (id): string => {
  return PROGRAM_TYPES.find((type) => type.id == id)!.name;
};

export function parseProgramListItemHigherToFrontEndModel(
  backEndModel: IProgramListItemHigherBackEnd,
): IProgramListItemHigherFrontEnd {
  const tuition = backEndModel.tuition;

  const otherFees = (backEndModel.otherFees ?? []).reduce(
    (sum, fee) => sum + fee.amount,
    0,
  );

  const commissionAmount = calculateFinancialSupport(
    tuition,
    true,
    backEndModel.commissionType,
    backEndModel.commissionAmount,
  );

  const tuitionScholarship = calculateFinancialSupport(
    tuition,
    backEndModel.hasTuitionScholarship,
    backEndModel.tuitionScholarshipType,
    backEndModel.tuitionScholarshipAmount,
  );

  const tuitionFinancialAid = calculateFinancialSupport(
    tuition,
    backEndModel.hasTuitionFinancialAid,
    backEndModel.tuitionFinancialAidType,
    backEndModel.tuitionFinancialAidAmount,
  );

  const otherFeesScholarship = calculateFinancialSupport(
    otherFees,
    backEndModel.hasOtherFeesScholarship,
    backEndModel.otherFeesScholarshipType,
    backEndModel.otherFeesScholarshipAmount,
  );

  const otherFeesFinancialAid = calculateFinancialSupport(
    otherFees,
    backEndModel.hasOtherFeesFinancialAid,
    backEndModel.otherFeesFinancialAidType,
    backEndModel.otherFeesFinancialAidAmount,
  );

  return {
    id: backEndModel.id,
    programType: getProgramTypeName(backEndModel.programType),
    majorName: backEndModel.majorName,
    intakes: [...backEndModel.intakes],
    tuition: toCurrency(tuition, backEndModel.currency, " "),
    otherFees: toCurrency(
      backEndModel.otherFees!.reduce((total, fee) => total + fee.amount, 0),
      backEndModel.currency,
      " ",
    ),
    isActive: backEndModel.isActive,
    commissionAmount: toCurrency(commissionAmount, backEndModel.currency, " "),
    scholarship: calculateAllFinancialSupport(
      tuitionScholarship,
      otherFeesScholarship,
      backEndModel.currency,
    ),
    financialAid: calculateAllFinancialSupport(
      tuitionFinancialAid,
      otherFeesFinancialAid,
      backEndModel.currency,
    ),
  };
}
